import React from "react";
import gpg from "../assets/gpg.txt";

const Footer = () => (
    <div style={{ fontSize: 12, color: "gray " }}>
        <div>
            Rendered with React and themed with Semantic UI. Publications provided by <a href="https://www.semanticscholar.org/">Semantic Scholar</a>.
        </div>
        <div>
            © {new Date().getFullYear()} Jonatan Hamberg, University of Helsinki. <a href={gpg}>My GPG key</a>.
        </div>
    </div>
);

export default Footer;